import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { CatalogDtosKeysEnum } from '@zaoblako/shared/modules/catalog/enums/catalog-dtos-keys.enum';
import { hexColorSchema } from '@zaoblako/shared/modules/serde/schemas/hex-color.schema';
import { nonEmptyStringSchema } from '@zaoblako/shared/modules/serde/schemas/non-empty-string.schema';
import { entityLikeSchema } from '@zaoblako/shared/modules/serde/schemas/entity-like.schema';
import type { UserFindInterface } from '@zaoblako/shared/modules/security/dtos/user/user-find.dto';
import type { UserGroupFindInterface } from '@zaoblako/shared/modules/security/dtos/user-group/user-group-find.dto';

import * as yup from 'yup';

/** Unit create/update request body */
export interface UnitFormInterface {
  /** Unit full name */
  name: string;
  /** Unit color */
  color?: string;
  /** Unit short name */
  short?: string;
  /** Special code of this unit for Atrium CRM (using by some reports) */
  atriumCode?: string;
  /** Is this unit using to distribute costs (`true` value must be a single for tenant) */
  distributeCosts?: boolean;
  /** Users who have access to this unit */
  users?: UserFindInterface[];
  /** User groups whose members have access to this unit */
  userGroups?: UserGroupFindInterface[];
}

/** Unit create/update request body DTO scheme */
export const UnitFormDto = SerdeDtoClass.create<UnitFormInterface>(CatalogDtosKeysEnum.UNIT_FORM_DTO, {
  name: {
    label: 'Название',
    serializer: nonEmptyStringSchema,
  },
  color: {
    optional: true,
    label: 'Цвет',
    serializer: hexColorSchema,
  },
  short: {
    optional: true,
    label: 'Сокращенное название',
    serializer: yup.string(),
  },
  atriumCode: {
    label: 'Код для "Атриума"',
    optional: true,
    serializer: yup.string(),
  },
  distributeCosts: {
    optional: true,
    label: 'Распределить затраты',
    serializer: yup.boolean(),
  },
  users: {
    optional: true,
    label: 'Пользователи',
    serializer: yup.array(entityLikeSchema),
  },
  userGroups: {
    optional: true,
    label: 'Группы',
    serializer: yup.array(entityLikeSchema),
  },
});
